import { render, staticRenderFns } from "./ShowResponseTab.vue?vue&type=template&id=22ceba76&scoped=true&"
import script from "./ShowResponseTab.vue?vue&type=script&lang=js&"
export * from "./ShowResponseTab.vue?vue&type=script&lang=js&"
import style0 from "./ShowResponseTab.vue?vue&type=style&index=0&id=22ceba76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ceba76",
  null
  
)

export default component.exports